import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo-new.svg'


const _hoisted_1 = { class: "bg-primary-dark" }
const _hoisted_2 = { class: "container mx-auto px-4 flex flex-wrap justify-between" }
const _hoisted_3 = { class: "w-full lg:w-1/4 md:py-8 py-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8",
  src: _imports_0,
  alt: "logo"
}, null, -1)
const _hoisted_5 = { class: "w-full lg:w-2/4 flex flex-wrap items-start lg:justify-around py-6 lg:px-10 px-0 justify-between" }
const _hoisted_6 = { class: "lg:m-4 m-0 text-white lg:mb-0 mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "INFORMATION", -1)
const _hoisted_8 = { class: "lg:m-4 m-0 text-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "RESOURCES", -1)
const _hoisted_10 = { class: "lg:m-4 m-0 text-white lg:hidden block" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "CONTACT", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "mailto:contact@bringbacktheforest.org"
  }, "contact@bringbacktheforest.org")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mb-8" }, [
  /*#__PURE__*/_createTextVNode(" Bring Back The Forest Co.,Ltd. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ITF Tower 140/6, Silom Road, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Suriya Wong, Bang Rak, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bangkok 10500 ")
], -1)
const _hoisted_14 = { class: "flex space-x-4" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "my-10 text-white lg:block hidden" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold mb-2" }, "CONTACT", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "mailto:contact@bringbacktheforest.org"
  }, "contact@bringbacktheforest.org")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "mb-8" }, [
  /*#__PURE__*/_createTextVNode(" Bring Back The Forest Co.,Ltd. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ITF Tower 140/6, Silom Road, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Suriya Wong, Bang Rak, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Bangkok 10500 ")
], -1)
const _hoisted_21 = { class: "flex -mx-2" }
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "w-full flex flex-wrap justify-between text-white md:text-sm text-xs lg:px-4 px-0" }
const _hoisted_25 = { class: "w-full md:w-1/2 mb-8 text-sm" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full md:w-1/2 mb-8 flex lg:justify-end space-x-2 text-right\"><span class=\"underline md:ml-auto ml-0\">Privacy Policy</span><span class=\"block\">·</span><span class=\"underline\">Terms</span><span class=\"block\">·</span><span class=\"underline\">Disclaimer</span><span class=\"block\">·</span><span class=\"underline\">Security Policy</span></div>", 1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const informations = [
  { name: 'Forest' },
  { name: 'Technology' },
  { name: 'Plant with us' },
];

const resources = [{ name: 'Whitepaper' }, { name: 'Community' }];

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(informations, (t, i) => {
            return _createElementVNode("div", {
              key: `technology-${i}`,
              class: "my-1"
            }, _toDisplayString(t.name), 1)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resources, (r, i) => {
            return _createElementVNode("div", {
              key: `resource-${i}`,
              class: "my-1"
            }, _toDisplayString(r.name), 1)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (s, i) => {
              return (_openBlock(), _createElementBlock("a", {
                key: `social-${i}`,
                class: "m-1",
                target: "_blank",
                href: s.to
              }, [
                _createElementVNode("img", {
                  class: "w-8",
                  src: s.img,
                  alt: ""
                }, null, 8, _hoisted_16)
              ], 8, _hoisted_15))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (s, i) => {
            return (_openBlock(), _createElementBlock("a", {
              key: `social-${i}`,
              class: "m-1",
              target: "_blank",
              href: s.to
            }, [
              _createElementVNode("img", {
                class: "w-8",
                src: s.img,
                alt: ""
              }, null, 8, _hoisted_23)
            ], 8, _hoisted_22))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, " © " + _toDisplayString(_unref(year)) + " Bring Back The Forest. All rights reserved. ", 1),
        _hoisted_26
      ])
    ])
  ]))
}
}

})